export class VrockFileHandler {
  public js_code = '';
  public block_xml = '';
  public project_id = '';
  public log_date: Date;

  static toVrockFileObject(xml: string, js: string): VrockFileHandler {
    const vrock: VrockFileHandler = new VrockFileHandler();
    vrock.js_code = js;
    vrock.block_xml = xml;
    return vrock;
  }

  toVrockFileString(xml: string, js: string): string {
    const obj = VrockFileHandler.toVrockFileObject(xml, js);
    return JSON.stringify(obj);
  }

  toVrockBackupObject(xml: string, js: string, project_id: string): VrockFileHandler {
    const obj = VrockFileHandler.toVrockFileObject(xml, js);
    obj.project_id = project_id;
    obj.log_date = new Date();
    return obj;
  }

  getFileName(title: string, project_id: string): string {
    const fileName = (title ? title : project_id) + '.vrock2';
    return fileName;
  }
}
